export default __webpack_public_path__ + "static/media/serviciosAlarma3Mobile.91f4b6c5.png";